import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 60px;
`;

const SummaryBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

const Title = styled.div`
  width: 100%;
  padding: 24px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-radius: 12px;
  border: 1px solid #dff0ff;
  background: #eff6ff;
  font-size: 24px;
  font-weight: 700;
  color: #008aff;
`;

const AnalyzeData = styled.span`
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  color: #616161;
`;

const Block = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const BlockTitle = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  font-size: 20px;
  font-weight: 700;
  color: #222;
`;
const BlockContent = styled.div`
  width: 100%;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  border-radius: 12px;
  border: 1px solid #e5e8ea;
`;
const Summary = styled.div`
  width: 100%;
  padding: 8px 24px;
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  background: rgba(112, 115, 124, 0.05);
`;

const SummaryRow = styled.div`
  width: 100%;
  height: 55px;
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
  border-bottom: 1px solid #e5e8ea;

  &:last-child {
    border-bottom: none;
  }
`;
const TitleCell = styled.div<{
  width: string;
  weight?: number;
  align?: string;
}>`
  width: ${(props) => props.width};
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: ${(props) => props.align || 'center'};
  font-size: 16px;
  font-weight: ${(props) => props.weight || 500};
  color: #222;
`;
const ContentCell = styled.div<{
  width: string;
  weight?: number;
  align?: string;
  grade?: number;
}>`
  width: ${(props) => props.width};
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: ${(props) => props.align || 'center'};
  font-size: 14px;
  font-weight: ${(props) => props.weight || 500};
  color: ${(props) =>
    props.grade === 1 ? '#F45551' : props.grade === 4 ? '#008AFF' : '#616161'};
`;
const RowItemInner = styled.div`
  width: 100%;
  padding: 0 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  font-size: 14px;
  font-weight: 500;
`;

const GradeBox = styled.div`
  width: 100%;
  height: 12px;
  border-radius: 4px;
  background: linear-gradient(
    90deg,
    rgba(193, 216, 235, 0.16) 0%,
    rgba(0, 138, 255, 0.16) 100%
  );
  position: relative;
`;

const Bar = styled.div<{ grade: number }>`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: ${(props) => props.grade * 20}%;
  height: 100%;
  background: linear-gradient(
    90deg,
    rgba(193, 216, 235, 0.16) 0%,
    rgba(0, 138, 255, 0.16) 100%
  );
  border-radius: 4px;
`;
const Tag = styled.div<{ grade: number }>`
  padding: 0px 8px;
  height: 29px;
  border-radius: 4px;
  background: ${(props) =>
    props.grade === 1 ? '#FFEFEF' : props.grade === 2 ? '#EEFFF6' : '#EAF2FE'};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
  color: #008aff;
  line-height: 145%;
`;
const Standard = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 40px;
  justify-content: flex-end;
  align-items: center;
  padding: 0 24px;
`;
const MyResultTag = styled.div`
  width: 206px;
  height: 58px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: #0c64ce;
  font-size: 18px;
  font-weight: 700;
  color: #fff;
`;
const NationalTag = styled.div`
  width: 206px;
  height: 58px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  border: 1px solid rgba(112, 115, 124, 0.16);
  font-size: 18px;
  font-weight: 700;
  color: #008aff;
`;

const GrayBox = styled.div`
  width: 100%;
  padding: 24px 24px 8px 24px;
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  background: rgba(70, 73, 82, 0.05);
`;
const BoxCategory = styled.div`
  width: 100%;
  padding-bottom: 16px;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  text-align: left;
  color: #222;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Row = styled.div`
  width: 100%;
  padding: 16px 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
  color: #222;
  border-bottom: 1px solid #e5e8ea;

  &:last-child {
    border-bottom: none;
  }
`;
const DataBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const Number = styled.span`
  width: 206px;
  text-align: center;
`;
const NationalNumber = styled.span`
  width: 206px;
  color: #616161;
  text-align: center;
`;

const VS = styled.span`
  width: 40px;
  font-size: 13px;
  font-weight: 400;
  color: rgba(55, 56, 60, 0.61);
  text-align: center;
`;
const SecondaryIndicator = styled.div`
  width: 100%;
  padding-top: 16px;

  span {
    width: 67px;
    height: 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    background: rgba(112, 115, 124, 0.08);
    font-size: 14px;
    font-weight: 500;
    color: rgba(55, 56, 60, 0.61);
  }
`;

export const s = {
  Container,
  SummaryBox,
  Title,
  AnalyzeData,
  Block,
  BlockTitle,
  Summary,
  SummaryRow,
  TitleCell,
  ContentCell,
  RowItemInner,
  GradeBox,
  Bar,
  Tag,
  BlockContent,
  Standard,
  MyResultTag,
  NationalTag,
  GrayBox,
  BoxCategory,
  Row,
  Number,
  NationalNumber,
  VS,
  DataBox,
  SecondaryIndicator,
};
